// @flow
import type {Action} from '../../../state/types'

export type SetLoadingPayload = {
  isLoading: boolean,
}

const id = 'gbiProject/SET_LOADING'

export const setLoading = (isLoading: boolean): Action<SetLoadingPayload> => ({
  type: id,
  payload: {
    isLoading,
  }
})

setLoading.id = id
